module.exports = "/_next/static/images/blue-cross-card-78a206b3610a84fb4b1d82a966e0705b.png";